
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/virtual/test",
      function () {
        return require("private-next-pages/virtual/test.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/virtual/test"])
      });
    }
  